import { inject, Injectable } from '@angular/core';
import { InstancesApiInterface } from './instances-api-interface';
import { CtHttpApiInterface } from '@hidat/ng-api';
import { PlayerMix, PlayerSession, PlayerStation, PlayerProgram, PlayerShow, PlayerHost, PlayerProfile } from '../../models';
import { HNG_APP_CONFIG } from '@hidat/ng-common';

@Injectable({ providedIn: 'root' })
export class PlayerApiService {
  private baseUrl: string;

  public readonly stations: CtHttpApiInterface<PlayerStation>;
  public readonly programs: CtHttpApiInterface<PlayerProgram>;
  public readonly hosts: CtHttpApiInterface<PlayerHost>;
  public readonly shows: CtHttpApiInterface<PlayerShow>;
  public readonly sessions: CtHttpApiInterface<PlayerSession>;
  public readonly instances: InstancesApiInterface;
  public readonly mixes: CtHttpApiInterface<PlayerMix>;
  public readonly listenerProfiles: CtHttpApiInterface<PlayerProfile>;

  constructor() {
    const config = inject(HNG_APP_CONFIG);
    this.baseUrl = config.apiUrl;

    this.stations = new CtHttpApiInterface<PlayerStation>(
      this.baseUrl,
      'stations',
      PlayerStation
    );

    this.programs = new CtHttpApiInterface<PlayerProgram>(
      this.baseUrl,
      'programs',
      PlayerProgram
    );

    this.hosts = new CtHttpApiInterface<PlayerHost>(
      this.baseUrl,
      'hosts',
      PlayerHost
    );

    this.shows = new CtHttpApiInterface<PlayerShow>(
      this.baseUrl,
      'shows',
      PlayerShow
    );

    this.mixes = new CtHttpApiInterface<PlayerMix>(
      this.baseUrl,
      'mixes',
      PlayerMix
    );

    this.sessions = new CtHttpApiInterface<PlayerSession>(
      this.baseUrl,
      'sessions',
      PlayerSession
    );

    this.instances = new InstancesApiInterface(
      this.baseUrl
    );

    this.listenerProfiles = new CtHttpApiInterface<PlayerProfile>(
      this.baseUrl,
      'listener_profiles',
      PlayerProfile,
    );
  }
}
